import { ReactComponent as IconSvg } from './icon_exclamation.svg';
import Icon, { IconProps } from './icon';

const IconExclamation = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconExclamation;
